import { Pagination } from "@mui/material";
import {
  AlertCircle,
  Edit,
  MoreHorizontal,
  Plus,
  Search,
  Shield,
  Trash2,
} from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  ADD_ROLE,
  DELETE_ROLE,
  EDIT_ROLE,
  LISTE_ROLE,
} from "../../Utils/constant";
import clientAxios from "../../services/axios";
import { find, store } from "../../services/service";
import { useRoleStore } from "../../store/RoleStore";

export const Role = () => {
  const role = useRoleStore();
  const [selectItem, setSelectItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRoleType, setSelectedRoleType] = useState("");
  const [roleSuperieur, setRoleSuperieur] = useState([]);
  const [msg, setMsg] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const [isSubmit, setIsSubmit] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const submit = (data) => {
    setIsSubmit(true);

    store(`${selectItem ? EDIT_ROLE : ADD_ROLE}`, "application/json", {
      ...data,
      designation: data.designation.replace(/ /g, "_"),
      id: selectItem ? selectItem.id : "",
    })
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          setSelectedRoleType("");
          document.getElementById("fermer_create_role").click();
          toast.success("Rôle ajouté avec succès");
          role.getData("page=0&param=&size=8&typeProfile=");
          ListRoles();
        }
      })
      .catch((err) => {
        document.getElementById("fermer_create_role").click();
        setIsSubmit(false);
        toast.error(
          err.response?.data?.donnee || "Erreur lors de l'ajout du rôle"
        );
      });
  };

  const ListRoles = () => {
    find(`${LISTE_ROLE}?page=0&param=&size=1000000&typeProfile=`).then(
      (result) => {
        setRoleSuperieur(result?.data?.data);
      }
    );
  };

  useEffect(() => {
    role.getData("page=0&param=&size=8&typeProfile=");
    ListRoles();
  }, []);

  useEffect(() => {
    if (selectItem) {
      const designation = selectItem?.designation || `[${selectItem?.id}]`;
      setValue("designation", designation);
      setValue("typeProfile", selectItem?.typeProfile || "");
      setValue("profileParentId", selectItem?.profileParentId || "");
    }
  }, [selectItem, setValue]);

  const more = (page) => {
    role.getData(`page=${page - 1}&param=${searchTerm}&size=8&typeProfile=`);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    role.getData(`page=0&param=${e.target.value}&size=8&typeProfile=`);
  };

  const type = [
    {
      index: "DOOR_TO_DOOR",
      label: "Door-to-Door",
    },
    {
      index: "AGENCE",
      label: "Agence",
    },
  ];

  return (
    <>
      <div className="min-h-screen bg-gray-50 p-6">
        {/* Header Section */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
                <div className="p-2 bg-amber-100 rounded-lg">
                  <Shield className="h-8 w-8 text-amber-600" />
                </div>
                Gestion des Rôles
              </h1>
              <p className="text-gray-600 mt-2">
                Gérez les rôles et permissions de votre système
              </p>
            </div>
          </div>

          {/* Search and Action Bar */}
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              <div className="flex items-center gap-2 ">
                <div className="relative flex-1 max-w-md">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Rechercher un rôle..."
                    value={searchTerm}
                    onChange={handleSearch}
                    className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg text-xs"
                  />
                </div>
                <select
                  className="select"
                  onChange={(e) => {
                    role.getData(
                      `page=0&param=&size=8&typeProfile=${e.target.value}`
                    );
                  }}
                >
                  <option value="">Sélectionnez un type de profil</option>
                  <option value="">Tout afficher</option>
                  {type.map((profil) => (
                    <option key={profil.index} value={profil.index}>
                      {profil.label}
                    </option>
                  ))}
                </select>
              </div>

              <button
                onClick={() => {
                  setSelectItem(null);
                  reset({
                    designation: "",
                  });
                  document.getElementById("add").showModal();
                }}
                className="flex items-center gap-2 bg-main hover:bg-amber-600 text-black px-4 py-3 rounded-lg font-medium "
              >
                <Plus className="h-4 w-4" />
                Ajouter un Rôle
              </button>
            </div>
          </div>
        </div>

        {/* Add Role Modal - Amélioré */}
        <dialog id="add" className="modal">
          <div className="modal-box max-w-xl">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="font-mtn text-2xl font-bold text-gray-900 flex items-center gap-3">
                  <div className="p-2 bg-amber-100 rounded-lg">
                    <Plus className="h-6 w-6 text-main" />
                  </div>
                  {selectItem
                    ? "Modification de rôle"
                    : "Ajouter un nouveau rôle"}
                </h2>
              </div>
              <form method="dialog">
                <button
                  id="fermer_create_role"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-red-100 text-gray-600 hover:text-red-600 transition-all duration-200"
                >
                  ✕
                </button>
              </form>
            </div>

            <form onSubmit={handleSubmit(submit)} className="p-6">
              <div className="space-y-6">
                <div className="my-2">
                  <label htmlFor="" className="text-sm font-medium">
                    Role <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder=""
                    className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                    {...register("designation", { required: true })}
                  />
                  {errors.designation && (
                    <span className="text-sm text-rose-600">
                      Ce champs est obligatoire
                    </span>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-3">
                    Type de profil
                  </label>
                  <select
                    {...register("typeProfile")}
                    className="w-full select"
                  >
                    <option value="">Sélectionnez un type de profil</option>
                    {type.map((profil) => (
                      <option
                        key={profil.index}
                        className="capitalize"
                        value={profil.index}
                      >
                        {profil.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-3">
                    Rôle du superieur
                  </label>
                  <select
                    {...register("profileParentId")}
                    className="w-full select"
                  >
                    <option value="">Sélectionnez un rôle</option>
                    {roleSuperieur?.map((roleOption) => (
                      <option
                        key={roleOption.id}
                        className="capitalize"
                        value={roleOption.id}
                      >
                        {roleOption?.id
                          ?.toLowerCase()
                          .replace(/role_/g, "")
                          .replace(/_/g, " ")}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-100">
                  <button
                    type="submit"
                    disabled={isSubmit}
                    className={`px-4 py-3 rounded-lg font-medium transition-all duration-200 flex items-center gap-2 ${
                      !isSubmit
                        ? "bg-main text-black"
                        : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                  >
                    {!isSubmit ? (
                      <>
                        <Plus className="h-4 w-4" />
                        Enregistrer
                      </>
                    ) : (
                      <>
                        <div className="w-4 h-4 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
                        Création en cours...
                      </>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </dialog>

        {/* Roles Grid - Amélioré */}
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="p-6 border-b border-gray-100">
            <h3 className="text-lg font-semibold text-gray-900">
              Liste des rôles
            </h3>
            <p className="text-gray-600 text-sm">
              Gérez les rôles et leurs permissions
            </p>
          </div>

          <div className="p-6">
            {role?.data?.data?.length === 0 ? (
              <div className="text-center py-12">
                <div className="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <Shield className="h-12 w-12 text-gray-400" />
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Aucun rôle trouvé
                </h3>
                <p className="text-gray-600 mb-4">
                  Commencez par ajouter votre premier rôle
                </p>
                <button
                  onClick={() => document.getElementById("add").showModal()}
                  className="inline-flex items-center gap-2 bg-main hover:bg-amber-600 text-black px-4 py-2 rounded-lg font-medium"
                >
                  <Plus className="h-4 w-4" />
                  Ajouter un rôle
                </button>
              </div>
            ) : role?.data?.data?.length !== 0 && !role?.loading ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {role?.data?.data?.map((item, index) => (
                  <div
                    key={index}
                    className="group relative bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg hover:border-amber-300 transition-all duration-300 transform hover:-translate-y-1"
                  >
                    {/* Dropdown Menu */}
                    <div className="absolute top-4 right-4">
                      <div className="dropdown dropdown-end">
                        <div
                          tabIndex={0}
                          role="button"
                          className="w-8 h-8 rounded-full flex items-center justify-center bg-gray-50 hover:bg-gray-100 text-gray-600 opacity-0 group-hover:opacity-100 transition-all duration-200"
                        >
                          <MoreHorizontal className="h-4 w-4" />
                        </div>
                        <ul className="dropdown-content z-10 menu p-2 shadow-xl bg-white rounded-xl border w-48 mt-2">
                          <li>
                            <button
                              className="flex items-center gap-3 p-3 hover:bg-gray-50 rounded-lg transition-colors duration-200"
                              onClick={() => {
                                setSelectItem(item);
                                document.getElementById("add").showModal();
                              }}
                            >
                              <Edit className="h-4 w-4 text-blue-600" />
                              <span className="text-gray-700">Modifier</span>
                            </button>
                          </li>
                          <li>
                            <button
                              onClick={() => {
                                setSelectItem(item);
                                document.getElementById("delete").showModal();
                              }}
                              className="flex items-center gap-3 p-3 hover:bg-red-50 rounded-lg transition-colors duration-200 text-red-600"
                            >
                              <Trash2 className="h-4 w-4" />
                              <span>Supprimer</span>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>

                    {/* Role Icon */}
                    <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-amber-200 transition-colors duration-300">
                      <Shield className="h-6 w-6 text-amber-600" />
                    </div>

                    {/* Role Info */}
                    <div>
                      <div className="flex items-center gap-2">
                        <h4 className="font-bold text-gray-900 text-sm mb-2 capitalize">
                          {item?.id
                            ?.toLowerCase()
                            .replace(/role_/g, "")
                            .replace(/_/g, " ")}{" "}
                        </h4>
                        {item?.typeProfile && (
                          <p className="badge text-xs truncate capitalize">
                            {item?.typeProfile.replace(/_/g, " ").toLowerCase()}
                          </p>
                        )}
                      </div>

                      {item?.parentId && (
                        <>
                          <p className="text-gray-600 text-sm mb-1">
                            Superieur
                          </p>

                          <div className="capitalize inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-700">
                            <div className=" w-2 h-2 bg-amber-400 rounded-full mr-2"></div>
                            {item?.parentId
                              ?.toLowerCase()
                              .replace(/role_/g, "")
                              .replace(/_/g, " ")}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex items-center justify-center py-12">
                <div className="w-10 h-10 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
              </div>
            )}
          </div>
          <div className="px-6 py-4 border-t border-gray-100 flex justify-center">
            <Pagination
              onChange={(event, newValue) => more(newValue)}
              count={role.count}
              variant="outlined"
              color="primary"
              shape="rounded"
              size="large"
            />
          </div>
          {/* Pagination */}
          {/* {role?.data?.data?.length > 0 && (
            <div className="px-6 py-4 border-t border-gray-100 flex justify-center">
              <Pagination
                onChange={(event, newValue) => more(newValue)}
                count={role.count}
                variant="outlined"
                color="primary"
                shape="rounded"
                size="large"
              />
            </div>
          )} */}
        </div>

        {/* Delete Confirmation Modal - Amélioré */}
        <dialog id="delete" className="modal">
          <div className="modal-box max-w-md bg-white rounded-2xl shadow-2xl">
            <div className="text-center p-6">
              <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                <Trash2 className="h-8 w-8 text-red-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Confirmer la suppression
              </h3>
              <p className="text-gray-600 mb-6">
                Êtes-vous sûr de vouloir supprimer ce rôle ? Cette action est
                irréversible.
              </p>
              <div className="flex items-center justify-center gap-3">
                <form method="dialog">
                  <button className="px-6 py-3 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-all duration-200">
                    Annuler
                  </button>
                </form>
                <dialog id="error" className="modal">
                  <div className="modal-box max-w-sm bg-white rounded-2xl shadow-2xl">
                    <div className="text-center p-6">
                      <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                        <AlertCircle className="h-8 w-8 text-red-600" />
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        Oops! Une erreur s'est produite
                      </h3>
                      <p className="text-gray-600 mb-6">{msg}</p>
                      <div className="flex items-center justify-center gap-3">
                        <button
                          onClick={() => {
                            document.getElementById("error").close();
                          }}
                          className="btn-sm rounded-md bg-red-500 text-white"
                        >
                          Fermer
                        </button>
                      </div>
                    </div>
                  </div>
                </dialog>
                <button
                  onClick={() => {
                    setIsDeleting(true);
                    clientAxios
                      .delete(
                        `${DELETE_ROLE}?profile=${selectItem.id.replace(
                          / /g,
                          "_"
                        )}`
                      )
                      .then(() => {
                        role.getData("page=0&param=&size=8&typeProfile=");
                        toast.success("Rôle supprimé avec succès");
                        ListRoles();
                      })
                      .catch((err) => {
                        setMsg(err.response?.data?.donnee);
                        document.getElementById("error").showModal();
                      })
                      .finally(() => {
                        setIsDeleting(false);
                        const dlg = document.getElementById("delete");
                        if (dlg) dlg.close();
                      });
                  }}
                  disabled={isDeleting}
                  className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 flex items-center gap-2 ${
                    isDeleting
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-red-600 hover:bg-red-700 text-white"
                  }`}
                >
                  {isDeleting ? (
                    <div className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  ) : (
                    <Trash2 className="h-4 w-4" />
                  )}
                  <span className="ml-2">
                    {isDeleting ? "Suppression..." : "Supprimer"}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </dialog>
      </div>
    </>
  );
};
